var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{attrs:{"show-arrows":false,"height":"170"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }